import { render } from "./TransactionDetail.vue?vue&type=template&id=c48d42f2&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"

import "./TransactionDetail.vue?vue&type=style&index=0&id=c48d42f2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48d42f2"]])

export default __exports__